const baseUrl = process.env.REACT_APP_LAMBDA_URL;
const adminBaseUrl = process.env.REACT_APP_ADMIN_LAMBDA_URL;
// const adminBaseUrl = "https://w72a5si42a.execute-api.ap-south-1.amazonaws.com/dev/v1";
// const adminBaseUrl = "https://dssqy2gip2.execute-api.ap-south-1.amazonaws.com/testing/v1"
// const adminBaseUrl = "http://localhost:3001/v1";

// const baseUrl = "https://3tplueug92.execute-api.ap-south-1.amazonaws.com/dev/v1";
// const baseUrl = "http://localhost:3002/v1"
// const baseUrl =
//   "https://173riv98n3.execute-api.ap-south-1.amazonaws.com/testing/v1";

const dynamicUrl = {
  //login
  login: baseUrl + "/login",
  loginWithOTP: baseUrl + "/loginWithOTP",
  validateOTP: baseUrl + "/validateOTP",
  logout: baseUrl + "/logout",

  // password management
  resetOrCreatePassword: baseUrl + "/resetOrCreatePassword",
  changePassword: baseUrl + "/changePassword",

  // class/section/subject
  fetchTeacherClasses: baseUrl + "/fetchTeacherClasses",
  fetchTeacherSectionsBasedonClass: baseUrl + "/fetchTeacherSectionsBasedonClass",
  fetchTeacherSubjectsBasedonSection: baseUrl + "/fetchTeacherSubjectsBasedonSection",

  //subject
  fetchUnitsandChaptersBasedonSubjects: baseUrl + "/fetchUnitsandChaptersBasedonSubjects",
  chapterUnlock: baseUrl + "/chapterUnlock",
  fetchTopicsBasedonChapter: baseUrl + "/fetchTopicsBasedonChapter",
  fetchDigicardsBasedonTopic: baseUrl + "/fetchDigicardsBasedonTopic",

  // unlock pre-topics
  fetchTopicAndNoOfQuestions: baseUrl + "/fetchTopicAndNoOfQuestions",

  // generate quiz
  fetchAvailableNumOfQuestions: baseUrl + "/fetchAvailableNumOfQuestions",
  getPreGrantedTeacherPermissions: baseUrl + "/getPreGrantedTeacherPermissions",
  getPostGrantedTeacherPermissions: baseUrl + "/getPostGrantedTeacherPermissions",
  generatePrePostQuiz: baseUrl + "/generatePrePostQuiz",
  fetchQuizTemplates: baseUrl + "/fetchQuizTemplates",

  //Digicard
  fetchIndividualDigiCard: baseUrl + "/fetchIndividualDigiCard",
  fetchDigicardExtension: baseUrl + "/fetchDigicardExtension",
  addDigicardExtension: baseUrl + "/addDigicardExtension",
  fetchDigiCardstoReorder: baseUrl + "/fetchDigiCardstoReorder",
  toggleDigicardsInTopic: baseUrl + "/toggleDigicardsInTopic",
  reArrangeDigiCardOrder: baseUrl + "/reArrangeDigiCardOrder",

  //unlock Digicards
  fetchAllPreTopicDigicards: baseUrl + "/fetchAllPreTopicDigicards",
  digicardUnlock: baseUrl + "/digicardUnlock",

  //topic
  archivedActiveTopicsInChapter: baseUrl + "/archivedActiveTopicsInChapter",
  fetchAllPostTopicDigicards: baseUrl + "/fetchAllPostTopicDigicards",

  // Question Papers
  fetchAllBluePrints: baseUrl + "/fetchAllBluePrints",
  fetchQuestionSourceandChapters: baseUrl + "/fetchQuestionSourceandChapters",
  fetchBlueprintById: baseUrl + "/fetchBlueprintById",
  fetchQuestionBasedOnBlueprint: baseUrl + "/fetchQuestionBasedOnBlueprint",
  fetchTopicsBasedonChapters: baseUrl + "/fetchTopicsBasedonChapters",
  fetchPostLearningTopicsBasedonChapters: baseUrl + "/fetchPostLearningTopics",
  fetchConceptsBasedonTopics: baseUrl + "/fetchConceptsBasedonTopics",
  addTestQuestionPaper: baseUrl + "/addTestQuestionPaper",
  fetchTestQuestionPapersBasedonStatus: baseUrl + "/fetchTestQuestionPapersBasedonStatus",
  validateQuestionPaperName: baseUrl + "/validateQuestionPaperName",
  toggleQuestionPaper: baseUrl + "/toggleQuestionPaper",
  viewTestQuestionPaper: baseUrl + "/viewTestQuestionPaper",

  //clasTestSchedule
  addClassTest: baseUrl + "/addClassTest",
  fetchClassTestsBasedonStatus: baseUrl + "/fetchClassTestsBasedonStatus",
  sendScannerLink: baseUrl + "/sendScannerLink",
  sendOTPForScanning: baseUrl + "/sendOTPForScanning",
  validateOTPForScanning: baseUrl + "/validateOTPForScanning",
  fetchSignedURLForAnswers: baseUrl + "/fetchSignedURLForAnswers",
  fetchClassTestById: baseUrl + "/fetchClassTestById",
  uploadAnswerSheets: baseUrl + "/uploadAnswerSheets",
  getStudentsBasedOnSection: baseUrl + "/getStudentsBasedOnSection",
  getStudentResultData: baseUrl + "/getStudentResultData",
  updateStudentMarks: baseUrl + "/updateStudentMarks",
  resetEvaluationStatus: baseUrl + "/resetEvaluationStatus",
  startEvaluation: baseUrl + "/startEvaluation",
  toggleClassTestStatus: baseUrl + "/toggleClassTestStatus",

  removeUploadedAnswerData: baseUrl + "/removeUploadedAnswerData",

  // Quiz
  fetchQuizBasedonStatus: baseUrl + "/fetchQuizBasedonStatus",
  toggleQuizStatus: baseUrl + "/toggleQuizStatus",
  viewQuizQuestionPaper: baseUrl + "/viewQuizQuestionPaper",
  getStudentQuizResultData: baseUrl + "/getStudentQuizResultData",
  checkDuplicateQuizName: baseUrl + "/checkDuplicateQuizName",
  fetchSignedURLForQuizAnswers: baseUrl + "/fetchSignedURLForQuizAnswers",
  uploadQuizAnswerSheets: baseUrl + "/uploadQuizAnswerSheets",
  resetQuizEvaluationStatus: baseUrl + "/resetQuizEvaluationStatus",
  updateStudentQuizMarks: baseUrl + "/updateStudentQuizMarks",
  startQuizEvaluation: baseUrl + "/startQuizEvaluation",
  getIndividualQuizReport: baseUrl + "/getIndividualQuizReport",


  // school   
  fetchIndividualSchool: adminBaseUrl + "/fetchIndividualSchool",
  schoolubscriptionFeatures: adminBaseUrl + "/schoolubscriptionFeatures",
  setQuizConfiguration: adminBaseUrl + "/setQuizConfiguration",
  setTestConfiguration: adminBaseUrl + '/setTestConfiguration',
  fetchUpschoolAndClientClasses: adminBaseUrl + "/fetchUpschoolAndClientClasses",
  classSubscribe: adminBaseUrl + "/classSubscribe",
  fetchClassBasedOnSchool: adminBaseUrl + "/fetchClassBasedOnSchool",   // reuse
  fetchSchoolSection: adminBaseUrl + "/fetchSchoolSection",
  addSection: adminBaseUrl + "/addSection",
  updateSchool: adminBaseUrl + "/updateSchool",
  fetchSectionById: adminBaseUrl + "/fetchSectionById",
  editSection: adminBaseUrl + "/editSection",
  fetchSectionByClientClassId: adminBaseUrl + "/fetchSectionByClientClassId",  // reuse
  teacherSectionAllocation: adminBaseUrl + "/teacherSectionAllocation",

  //Section
  saveTimetableConfiguration: baseUrl + `/saveTimetableConfiguration`,
  getSectionById: baseUrl + `/getSectionById`,

  //Users
  usersPagination: adminBaseUrl + "/usersPagination",
  createSchoolAdmin: baseUrl + "/createSchoolAdmin",
  updateSchoolAdmin: baseUrl + "/updateSchoolAdmin",
  fetchTeacherInfoDetails: adminBaseUrl + "/fetchTeacherInfoDetails",
  fetchIndividualUserByRole: adminBaseUrl + "/fetchIndividualUserByRole",
  updateUsersByRole: adminBaseUrl + "/updateUsersByRole",
  fetchSubjectForClientClass: adminBaseUrl + "/fetchSubjectForClientClass", // reuse
  fetchTeacherClassAndSection: adminBaseUrl + "/fetchTeacherClassAndSection",
  mappingSubjectToTeacher: adminBaseUrl + "/mappingSubjectToTeacher",
  fetchMappedSubjectForTeacher: adminBaseUrl + "/fetchMappedSubjectForTeacher",
  toggleUserStatus: adminBaseUrl + "/toggleUserStatus",
  bulkToggleUsersStatus: adminBaseUrl + "/bulkToggleUsersStatus",
  bulkUsersUpload: adminBaseUrl + "/bulkUsersUpload",
  bulkToggleCMSUserStatus: adminBaseUrl + "/bulkToggleCMSUserStatus",
  getUserBulkuploadUrl: adminBaseUrl + "/getUserBulkuploadUrl",
  toggleSchoolAdminStatus: baseUrl + "/toggleSchoolAdminStatus",

  //dashboard
  getTargetedLearningExpectation: baseUrl + '/getTargetedLearningExpectation',
  getAssesmentSummaryDetails: baseUrl + '/getAssesmentSummaryDetails',
  fetchAssessmentSummary: baseUrl + '/fetchAssessmentSummary',
  getTargetedLearningExpectationDetails: baseUrl + '/getTargetedLearningExpectationDetails',
  preLearningSummaryDetails: baseUrl + '/preLearningSummaryDetails',
  postLearningSummaryDetails: baseUrl + '/postLearningSummaryDetails',
  preLearningBlueprintDetails: baseUrl + '/preLearningBlueprintDetails',
  viewAnalysisIndividualReport: baseUrl + '/viewAnalysisIndividualReport',
  comprehensivePerformanceChapterWise: baseUrl + '/comprehensivePerformanceChapterWise',
  comprehensivePerformanceTopicWise: baseUrl + '/comprehensivePerformanceTopicWise',
  comprehensivePerformanceConceptWise: baseUrl + '/comprehensivePerformanceConceptWise',
  getActionsAndRecommendations: baseUrl + '/getActionsAndRecommendations',
  getActionsAndRecommendationDetail: baseUrl + '/getActionsAndRecommendationDetail',
  viewClassReportQuestionsTest: baseUrl + '/viewClassReportQuestionsTest',
  viewClassReportQuestions: baseUrl + '/viewClassReportQuestions',
  viewClassReportFocusAreaTest: baseUrl + '/viewClassReportFocusAreaTest',
  viewClassReportFocusArea: baseUrl + '/viewClassReportFocusArea',
  viewChapterwisePerformanceTracking: baseUrl + '/viewChapterwisePerformanceTracking',
  fetchSchoolDetails: baseUrl + '/fetchSchoolDetails',
  fetchBlueprintDetailsBasedonId: baseUrl + '/fetchBlueprintDetailsBasedonId',

  getTargetedLearningExpectation: baseUrl + '/getTargetedLearningExpectation',
  getAssesmentSummaryDetails: baseUrl + '/getAssesmentSummaryDetails',
  fetchAssessmentSummary: baseUrl + '/fetchAssessmentSummary',
  getTargetedLearningExpectationDetails: baseUrl + '/getTargetedLearningExpectationDetails',
  preLearningSummaryDetails: baseUrl + '/preLearningSummaryDetails',
  postLearningSummaryDetails: baseUrl + '/postLearningSummaryDetails',
  preLearningBlueprintDetails: baseUrl + '/preLearningBlueprintDetails',
  viewAnalysisIndividualReport: baseUrl + '/viewAnalysisIndividualReport',
  comprehensivePerformanceChapterWise: baseUrl + '/comprehensivePerformanceChapterWise',
  comprehensivePerformanceChapterWiseForTest: baseUrl + '/comprehensivePerformanceChapterWiseForTest',
  comprehensivePerformanceTopicWise: baseUrl + '/comprehensivePerformanceTopicWise',
  comprehensivePerformanceTopicWiseForTest: baseUrl + '/comprehensivePerformanceTopicWiseForTest',
  comprehensivePerformanceConceptWise: baseUrl + '/comprehensivePerformanceConceptWise',
  comprehensivePerformanceConceptWiseForTest: baseUrl + '/comprehensivePerformanceConceptWiseForTest',
  getActionsAndRecommendations: baseUrl + '/getActionsAndRecommendations',
  getActionsAndRecommendationDetail: baseUrl + '/getActionsAndRecommendationDetail',
  viewClassReportQuestions: baseUrl + '/viewClassReportQuestions',
  viewClassReportFocusArea: baseUrl + '/viewClassReportFocusArea',
  viewChapterwisePerformanceTracking: baseUrl + '/viewChapterwisePerformanceTracking',
  fetchSchoolDetails: baseUrl + '/fetchSchoolDetails',
  fetchBlueprintDetailsBasedonId: baseUrl + '/fetchBlueprintDetailsBasedonId',


  topAndBottomPerformers: baseUrl + '/topAndBottomPerformers',
  needAttention: baseUrl + '/needAttention',
  studentChaptersPerformance: baseUrl + '/studentChaptersPerformance',
  customWorksheetGenerated: baseUrl + '/customWorksheetGenerated',
  fetchCustomWorksheet: baseUrl + '/fetchCustomWorksheet',
  sendEmailToParent: baseUrl + '/sendEmailToParent',
  fetchAllStudents: baseUrl + '/fetchAllStudents',
  studentAvgVsClassAvgChapterWise: baseUrl + '/studentAvgVsClassAvgChapterWise',

  updateActionAndRecommendations: baseUrl + '/updateActionAndRecommendations',
  upsertTeacherAttendance: baseUrl + '/upsertTeacherAttendance',
  fetchTeacherAttendance: baseUrl + '/fetchTeacherAttendance',
  sendWhatsAppToParent: baseUrl + '/sendWhatsAppToParent',
  fetchAllChaptersBySubjectId: baseUrl + '/fetchAllChaptersBySubjectId',
  // addAcademicPlanToSections:baseUrl + '/addAcademicPlanToSections',
  addCurriculumPlanToSection: baseUrl + '/addCurriculumPlanToSection',













}

export default dynamicUrl;